import { apiConfig } from '../config';
import { getFetch } from '../fetch';

export function getThemeDetails(themeId: any, grades: any) {
    const { apiGetThemeDetails } = apiConfig.getStaticUrls();

    return getFetch(apiGetThemeDetails, {
        themeId,
        grades: grades ? grades.join(',') : undefined,
    });
}
